import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { MessageService } from 'primeng/api'

import { ApiQuoteParametersService } from '../../data/services/api/api-quote-parameters.service'
import { ASSET_TYPE_OPTIONS, assetTypeLabel } from '@data/constants/asset-types'
import { AuthService } from '@data/services/modules/auth/auth.service'

/**
 * Plan v4.3 §7 · El tipo de activo que eligió el cliente, en la cotización y en el arrendamiento. Quien puede editar
 * cotizaciones lo corrige aquí; la versión anterior queda en el historial de la cotización.
 */
@Component({
  selector: 'app-asset-type-field',
  templateUrl: './asset-type-field.component.html',
  styleUrls: ['./asset-type-field.component.scss'],
  providers: [MessageService],
})
export class AssetTypeFieldComponent implements OnChanges {
  @Input() quotationParametersId: string | null = null
  @Input() assetType: string | null = null
  @Output() changed = new EventEmitter<string>()

  readonly options = ASSET_TYPE_OPTIONS
  readonly canEdit: boolean
  editing = false
  saving = false
  selected: string | null = null

  constructor(
    private api: ApiQuoteParametersService,
    private messageService: MessageService,
    authService: AuthService,
  ) {
    this.canEdit = authService.hasModulePermission('quotations', 'update')
  }

  get label(): string {
    return assetTypeLabel(this.assetType)
  }

  ngOnChanges(): void {
    this.selected = this.assetType
  }

  startEdit(): void {
    this.selected = this.assetType
    this.editing = true
  }

  cancel(): void {
    this.editing = false
  }

  save(): void {
    if (!this.quotationParametersId || !this.selected || this.selected === this.assetType) {
      this.editing = false
      return
    }
    this.saving = true
    this.api.updateAssetType(this.quotationParametersId, this.selected).subscribe((response) => {
      this.saving = false
      if (response.error) {
        this.messageService.add({ severity: 'error', summary: 'No se pudo cambiar', detail: response.msg, life: 5000 })
        return
      }
      this.assetType = this.selected
      this.editing = false
      this.messageService.add({ severity: 'success', summary: 'Tipo de activo actualizado', detail: assetTypeLabel(this.selected), life: 3000 })
      this.changed.emit(this.selected as string)
    })
  }
}
